import { render } from "./PasswordExpirationAlert.vue?vue&type=template&id=4c2060f8&scoped=true&lang=pug"
import script from "./PasswordExpirationAlert.vue?vue&type=script&lang=js"
export * from "./PasswordExpirationAlert.vue?vue&type=script&lang=js"

import "./PasswordExpirationAlert.vue?vue&type=style&index=0&id=4c2060f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c2060f8"]])

export default __exports__